import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../images/aad-logo.png";

import axios from "axios";
import config from "../../services/config";
import { useHistory } from "react-router-dom";
// import Cookies from 'js-cookie'
// import sandalmistLogo from "../../images/linnkLogo.jpeg";
import login_banner from "../../images/login_banner.jpeg";
// import bg2 from "../../images/bg3.jpg";
// import bg2 from "../../images/000.jpg";
// import bg2 from "../../images/compressdimg.jpeg";
// import bg2 from "../../images/nnnn.jpeg";
// import bg2 from "../../images/11111.PNG";
import bg2 from "../../images/bg2.jpg";
// image
// import logo from "../../images/logo-full.png";
//import loginbg from "../../images/pic1.png";
import Cookies from "js-cookie";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
  MsalProvider,
} from "@azure/msal-react";

import { loginRequest, msalConfig } from "./authConfig";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { Button } from "react-bootstrap";
import {
  Redirect,
  Route,
  Router,
} from "react-router-dom/cjs/react-router-dom.min";
import Home from "../components/Dashboard/Home";
const msalInstance = new PublicClientApplication(msalConfig);
console.log("msalInstance: ", msalInstance);

if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    console.log("event: ", event);
    const account = event.payload.account;
    console.log("account: ", account);
    msalInstance.setActiveAccount(account);

    const jwtToken = account.idToken;
    if (jwtToken) {
      console.log("jwtToken: ", jwtToken);
      // Store the token in sessionStorage
      window.sessionStorage.setItem("jwtToken", jwtToken);
    }
  }
});
const jwtToken = window.sessionStorage.getItem("jwtToken");
// console.log('jwtToken: ', jwtToken);

const WrappedView = () => {
  const { instance } = useMsal();
  console.log("instance_______: ", instance);
  const activeAccount = instance.getActiveAccount;
  if (activeAccount) {
    window.sessionStorage.setItem("clientadminlogin", true);
    Cookies.set("Level", "0");
  }

  const handleRedirect = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: "create",
      })
      .catch((error) => console.log(error));
  };

  return (
    <div className="app">
      <AuthenticatedTemplate>
        <Router>
          {/* Redirect to Dashboard if activeAccount exists */}
          {activeAccount ? (
            <Redirect to="/TMS/dashboard" />
          ) : (
            // <>hello</>
            <div>You need to log in.</div>
          )}

          {/* Routes */}
          <Route path="/" component={Home} />
        </Router>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Button className="w-100 " onClick={handleRedirect} size="md">
          <img src={logo} alt="Icon" className="azure-icon icon" />
          Sign In With Azure Active Directory
        </Button>{" "}
        {/* <button onClick={handleRedirect}>Sign Up</button> */}
      </UnauthenticatedTemplate>
    </div>
  );
};

function Login(props) {
  //   const [email, setEmail] = useState('demo@example.com');
  const [email, setEmail] = useState("");
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  // const [password, setPassword] = useState('123456');
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginData, setloginData] = useState();

  const history = useHistory();

  useEffect(() => {
    if (loginData !== undefined && loginData !== null) {
      handleLogin(loginData);
    }
  }, [loginData]);

  const dispatch = useDispatch();

  function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    const loginObj = {
      username: email,
      password: password,
    };
    LoginApi(loginObj);
  }

  // dispatch(loginAction(email, password, props.history));

  function LoginApi(loginObj) {
    setLoading(true);
    axios({
      url: config.baseUrl + "adminLogin",
      method: "POST",
      "Content-Type": "application/json",
      headers: {
        token: sessionStorage.getItem("token"),
      },
      data: loginObj,
    })
      .then((res) => {
        // console.log("res", res.status.data);
        if (res.status === 200) {
          Cookies.set("Level", res.data.data.level);
          setloginData(res.data.data.level);
          history.push("/dashboard");
          // window.sessionStorage.setItem("clientadminlogin",JSON.stringify( {'token':response.data.data.token, 'id':response.data.data.id, 'client':response.data.data.client, isLogin:true }));
          window.sessionStorage.setItem("clientadminlogin", true);
          window.sessionStorage.setItem("token", res.data.data.token);
          window.sessionStorage.setItem("id", res.data.data.id);

          let terminalAccessList = JSON.stringify(res.data.data.terminalAccess);
          window.sessionStorage.setItem("terminalAccess", terminalAccessList);

          // window.sessionStorage.setItem("ClientName",response.data.data.client);
          // window.sessionStorage.setItem("ClientImgUrl",response.data.data.clientImgUrl);
          //  dispatch(loadingToggleAction(true));
          // dispatch(loginConfirmedAction(response.data));

          // window.location.reload()
        }
        if (res.status === 201) {
          alert(res.data.message); //
          console.log(res.data.message);
          console.log("vikas01");
        }
        if (res.status === 202) {
          alert(res.data.message);
          console.log("res");
          // alert("you are unauthorized.. please login to continue");
          console.log("vikas02");
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response?.data.status === 401) {
          alert("you are unauthorized.. please login to continue");
          //   window.location = '/page-login'
        }
        setLoading(false);
      });
  }

  const handleLogin = () => {
    // Simulating user login
    const userLevel = loginData; // or 'superAdmin'

    // Set cookies based on user access levels
    if (userLevel === 0) {
      Cookies.set("Level", 0); // Cookie for admin level with 7 days expiration
    } else if (userLevel === 1) {
      Cookies.set("Level", 1); // Cookie for super admin level with 7 days expiration
    }
    // Redirect or perform further actions after successful login
  };
  handleLogin(loginData);
  return (
    <>
      <div
        className="authincation h-100 w-100 py-5 d-flex justify-content-center align-items-center"
        style={{
          backgroundImage: `url(${bg2})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          // filter: 'brightness(0.75) blur(2px)'
        }}
      >
        {" "}
        <div className="container h-100 d-flex justify-content-center align-items-center ">
          <div
            className="card col-xl-4 w-50 pb-5 d-flex justify-content-center "
            style={{ backgroundColor: "rgba(255, 255, 255, 0.7)" }}
          >
            <div className="auth-form rounded-4">
              <h2 className="text-center mb-2">BIAL</h2>
              <h3 className="text-center mb-2 mt-2">
                Trolley Management System
              </h3>
              {/* <h4 className="text-center mb-4">Sign in to your account</h4> */}
              {/* Your form content */}
              <form onSubmit={onLogin}>
                {/* <div className="mb-3">
                  <label className="mb-1 text-black">
                    <strong>User Name</strong>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Type Your User Name"
                  />
                  {errors.email && (
                    <div className="text-danger fs-12">{errors.email}</div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="mb-1 text-black">
                    <strong>Password</strong>
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    placeholder="Type Your Password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {errors.password && (
                    <div className="text-danger fs-12">{errors.password}</div>
                  )}
                </div> */}
                {/* <div className="form-row d-flex justify-content-between mt-4 mb-2">
                        <div className="mb-3">
                           <div className="form-check custom-checkbox ms-0">
                            <input type="checkbox" className="form-check-input" id="basic_checkbox_1" />
                            <label className="form-check-label" htmlFor="basic_checkbox_1">Remember my preference</label>
                          </div>
                        </div>													
                      </div> */}
                {/* {error && (
                        // Show the error message if it exists
                        <div className="alert alert-danger" role="alert">
                          {error}
                        </div>
                      )} */}
                <div className="text-center">
                  {/* <button
                    onClick={handleLogin}
                    type="submit"
                    className="mb-3 btn btn-primary btn-block"
                    disabled={loading} // Disable the button when loading is true
                  >
                    {loading ? (
                      // Show the small rounding loader while the response is being processed
                      <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      // Show the "Sign In" text when not loading
                      "Sign In"
                    )}
                  </button> */}
                  <MsalProvider instance={msalInstance}>
                    <WrappedView />
                  </MsalProvider>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>

    // <>
    //   <div className="authincation h-100 py-5 " style={{backgroundImage: `url(${bg2})`,backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
    //     <div className="container h-100 mt-5 ">
    //       <div className="row d-flex justify-content-center h-100 align-items-center">
    //         <div className="col-md-6 ">
    //           <div className="authincation-content">
    //             <div className="row no-gutters">
    //               <div className="col-xl-12">
    //               <div className="auth-form rounded-4" style={{ backgroundColor:"black",opacity:5}}>
    //                   <div className="text-center mb-3">
    //                     <Link to={"#"}>
    //                       <img src={login_banner} height="250" alt="" />
    //                       {/* <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
    // 												<rect width="57" height="57" rx="14" fill="#FFD482"/>
    // 												<path d="M33.8661 45.3198L34.016 45.5H34.2504H42H43.0867L42.3797 44.6747L29.6972 29.8694L42.0311 15.3234L42.7292 14.5H41.6497H34.2504H34.015L33.8651 14.6814L23.6296 27.0631V15V14.5H23.1296H17H16.5V15V45V45.5H17H23.1296H23.6296V45V33.016L33.8661 45.3198Z" fill="#2D3134" stroke="#2D3134"/>
    // 												<path d="M49.609 37.1129L49.6065 37.1153L45.8935 40.7348L46.7704 45.847L46.7705 45.8478C46.8764 46.468 46.622 47.0949 46.113 47.4658L49.609 37.1129ZM49.609 37.1129C50.0552 36.6749 50.222 36.0196 50.0254 35.4164L49.0746 35.7263L50.0254 35.4164C49.8302 34.8175 49.3123 34.3807 48.6885 34.2897L48.6878 34.2896L43.5562 33.5445L41.2613 28.8938C41.2613 28.8938 41.2612 28.8938 41.2612 28.8938C40.9426 28.248 40.2969 28 39.7756 28C39.2543 28 38.6085 28.248 38.2899 28.8938L35.995 33.5445L30.8633 34.2896L30.8626 34.2897C30.2377 34.3808 29.721 34.8192 29.526 35.4156C29.3292 36.0177 29.4952 36.6758 29.9435 37.1142L29.9447 37.1154L33.6583 40.7342L32.7814 45.8463L32.7813 45.8471M49.609 37.1129L32.7813 45.8471M32.7813 45.8471C32.6755 46.4673 32.9299 47.0942 33.4388 47.4652M32.7813 45.8471L33.4388 47.4652M33.4388 47.4652C33.9498 47.8383 34.6282 47.8867 35.1863 47.5918C35.1868 47.5915 35.1873 47.5913 35.1878 47.591L39.7756 45.1795L44.3657 47.5925L33.4385 47.4649C33.4386 47.465 33.4387 47.4651 33.4388 47.4652ZM45.1374 47.7835C45.4783 47.7835 45.822 47.6782 46.1129 47.4659L44.3668 47.5931C44.6093 47.7208 44.8745 47.7835 45.1374 47.7835Z" fill="url(#paint0_linear_33_278)" stroke="#FFD482" strokeWidth="2"/>
    // 												<defs>
    // 												<linearGradient id="paint0_linear_33_278" x1="39.7756" y1="29" x2="39.7756" y2="46.7835" gradientUnits="userSpaceOnUse">
    // 												<stop offset="2" stopColor="#FF9D43"/>
    // 												<stop offset="1" stopColor="#F66F4D"/>
    // 												</linearGradient>
    // 												</defs>
    // 											</svg>
    // 											<svg className="page-logo ms-2" width="110" height="33" viewBox="0 0 110 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    // 												<path d="M0.5 31.6275V32.1275H1H6.77194H7.27194V31.6275V23.2943L14.1312 31.9383L14.2813 32.1275H14.5228H22.0264H23.1389L22.4002 31.2955L12.5506 20.2017L22.3203 9.02737L23.0452 8.19826H21.9439H14.4404H14.1979L14.0477 8.3887L7.27194 16.9828V1V0.5H6.77194H1H0.5V1V31.6275ZM41.0678 10.605C39.5233 9.04976 37.1689 7.82577 34.0231 7.82577C27.8956 7.82577 23.0924 12.6836 23.0924 20.0801C23.0924 27.4655 27.8854 32.5 33.9819 32.5C37.0937 32.5 39.5015 31.2757 41.0678 29.6684V31.6275V32.1275H41.5678H47.381H47.881V31.6275V8.69826V8.19826H47.381H41.5678H41.0678V8.69826V10.605ZM84.4701 31.6275V32.1275H84.9701H90.7421H91.2421V31.6275V18.1762C91.2421 14.9065 90.2393 12.3172 88.4732 10.5442C86.7078 8.77197 84.2313 7.86715 81.3833 7.86715C78.175 7.86715 75.2441 9.42776 73.5593 11.8096C71.8164 9.22484 68.9104 7.86715 65.5104 7.86715C63.0449 7.86715 60.8509 8.72757 59.2903 10.1773V8.69826V8.19826H58.7903H53.0183H52.5183V8.69826V31.6275V32.1275H53.0183H58.7903H59.2903V31.6275V18.9626C59.2903 17.2319 59.769 15.9839 60.5522 15.1706C61.3334 14.3592 62.479 13.9166 63.9438 13.9166C65.3637 13.9166 66.4889 14.3571 67.2612 15.1685C68.0361 15.9825 68.5148 17.2319 68.5148 18.9626V31.6275V32.1275H69.0148H74.7868H75.2868V31.6275V18.9626C75.2868 17.2319 75.7655 15.9832 76.5445 15.1695C77.3213 14.3582 78.4567 13.9166 79.8991 13.9166C81.319 13.9166 82.4441 14.3571 83.2165 15.1685C83.9913 15.9825 84.4701 17.2319 84.4701 18.9626V31.6275ZM109 14.9513H109.5V14.4513V8.36715V7.86715H109C106.248 7.86715 104.04 8.96175 102.491 10.7325V8.69826V8.19826H101.991H96.2193H95.7193V8.69826V31.6275V32.1275H96.2193H101.991H102.491V31.6275V20.2043C102.491 18.0564 102.992 16.782 103.792 16.0317C104.598 15.2759 105.812 14.9513 107.475 14.9513H109ZM41.0678 20.1629C41.0678 22.221 40.387 23.7769 39.3706 24.8161C38.3515 25.858 36.9676 26.4092 35.5073 26.4092C32.71 26.4092 29.988 24.1688 29.988 20.0801C29.988 18.0245 30.6774 16.4904 31.6924 15.4715C32.7111 14.4488 34.0859 13.9166 35.5073 13.9166C36.9676 13.9166 38.3515 14.4678 39.3706 15.5097C40.387 16.5488 41.0678 18.1048 41.0678 20.1629Z" fill="#2D3134" stroke="#2D3134"/>
    // 											</svg> */}
    //                     </Link>
    //                   </div>
    //                   <h4 className="text-center mb-4">
    //                     Welcome to Trolley Mangment System
    //                   </h4>
    //                   <h6 className="text-center mb-4">Sign in your account</h6>
    //                   {props.errorMessage && (
    //                     <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
    //                       {props.errorMessage}
    //                     </div>
    //                   )}
    //                   {props.successMessage && (
    //                     <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
    //                       {props.successMessage}
    //                     </div>
    //                   )}
    //                   <form onSubmit={onLogin}>
    //                     <div className="mb-3">
    //                       <label className="mb-1">
    //                         <strong>User Name</strong>
    //                       </label>
    //                       <input
    //                         type="text"
    //                         className="form-control"
    //                         value={email}
    //                         onChange={(e) => setEmail(e.target.value)}
    //                         placeholder="Type Your User Name"
    //                       />
    //                       {errors.email && (
    //                         <div className="text-danger fs-12">
    //                           {errors.email}
    //                         </div>
    //                       )}
    //                     </div>
    //                     <div className="mb-3">
    //                       <label className="mb-1">
    //                         <strong>Password</strong>
    //                       </label>
    //                       <input
    //                         type="password"
    //                         className="form-control"
    //                         value={password}
    //                         placeholder="Type Your Password"
    //                         onChange={(e) => setPassword(e.target.value)}
    //                       />
    //                       {errors.password && (
    //                         <div className="text-danger fs-12">
    //                           {errors.password}
    //                         </div>
    //                       )}
    //                     </div>
    //                     {/* <div className="form-row d-flex justify-content-between mt-4 mb-2">
    // 											<div className="mb-3">
    // 											   <div className="form-check custom-checkbox ms-0">
    // 													<input type="checkbox" className="form-check-input" id="basic_checkbox_1" />
    // 													<label className="form-check-label" htmlFor="basic_checkbox_1">Remember my preference</label>
    // 												</div>
    // 											</div>
    // 										</div> */}
    //                     {/* {error && (
    // 											// Show the error message if it exists
    // 											<div className="alert alert-danger" role="alert">
    // 												{error}
    // 											</div>
    // 										)} */}
    //                     <div className="text-center">
    //                       <button
    //                         onClick={handleLogin}
    //                         type="submit"
    //                         className="btn btn-primary btn-block"
    //                         disabled={loading} // Disable the button when loading is true
    //                       >
    //                         {loading ? (
    //                           // Show the small rounding loader while the response is being processed
    //                           <div
    //                             className="spinner-border text-light"
    //                             role="status"
    //                           >
    //                             <span className="visually-hidden">
    //                               Loading...
    //                             </span>
    //                           </div>
    //                         ) : (
    //                           // Show the "Sign In" text when not loading
    //                           "Sign In"
    //                         )}
    //                       </button>
    //                     </div>
    //                   </form>
    //                   {/* <div className="new-account mt-3">
    // 										<p className="mb-0 mb-sm-3">Don't have an account? <Link to={"./page-register"} className="text-primary">Sign up</Link></p>
    // 									</div> */}
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Login);
